/**
 * Realizzazione — Cover video play.
 *
 * Il video della cover parte solo su interazione (niente autoplay): il pulsante
 * play lo avvia e mostra i controlli nativi; la classe .is-playing nasconde il
 * pulsante mentre il video è in riproduzione e lo ripristina in pausa.
 *
 * L'elemento <video> nasce vuoto: la sorgente ("Video Storia Completa", campo
 * ACF story_videofull) arriva da data-story-src e viene assegnata al primo
 * click, così la pagina non scarica il filmato a chi non lo chiede. Lo scambio
 * avviene una volta sola — dal secondo click in poi il pulsante riprende da
 * dov'era, che è quello che ci si aspetta dopo una pausa.
 *
 * .is-story-active viene aggiunta quando il video parte davvero (evento play)
 * e non viene più tolta: è lei a far salire il video sopra l'immagine in
 * evidenza in dissolvenza, e deve restare anche a video in pausa, altrimenti
 * l'immagine tornerebbe a coprire il fotogramma fermo.
 *
 * Markup: template-parts/realizzazioni/cover.php ([data-cover-video]).
 */
( function () {
	'use strict';

	const section = document.querySelector( '[data-cover-video]' );
	if ( ! section ) {
		return;
	}

	const video = section.querySelector( '.js-cover-video' );
	const button = section.querySelector( '.js-cover-play' );
	if ( ! video || ! button ) {
		return;
	}

	const storySrc = video.getAttribute( 'data-story-src' ) || '';
	let storyLoaded = false;

	button.addEventListener( 'click', () => {
		if ( storySrc && ! storyLoaded ) {
			storyLoaded = true;
			video.src = storySrc;
		}

		video.controls = true;
		const played = video.play();
		if ( played && typeof played.catch === 'function' ) {
			played.catch( () => {} ); // ignora l'eventuale rifiuto del browser
		}
	} );

	video.addEventListener( 'play', () => {
		section.classList.add( 'is-playing' );
		section.classList.add( 'is-story-active' );
	} );
	video.addEventListener( 'pause', () => section.classList.remove( 'is-playing' ) );
}() );
